import { useCallback, useEffect, useState } from 'react'

import { api } from 'app/api'
import {
  POST_ACQUIRING_ORDERS,
  convertParams,
  convertResult,
} from 'app/common/api/requests/payments/acquiring2/orders/post'

import { AcquiringOrder, Params } from 'app/dataTypes/acquiring/order'

export function useAcquiringOrder({
  id,
  ownerType,
  refillType,
  amount,
  successURL,
  failureURL,
  recurrentSave,
  recurrentCardId,
}: Params) {
  const [loading, setLoading] = useState(true)
  const [order, setOrder] = useState<AcquiringOrder | null>(null)

  const request = useCallback(async () => {
    setLoading(true)
    const res = await api.request(POST_ACQUIRING_ORDERS, {
      error: 'Не удалось получить информацию по ордеру эквайринга',
      params: {
        id,
        ownerType,
        refillType,
        amount,
        successURL,
        failureURL,
        recurrentSave,
        recurrentCardId,
      },
      convertions: {
        convertParams,
        convertResult,
      },
    })

    setLoading(false)

    if (res) {
      setOrder(res)
    }
  }, [id, ownerType, refillType, amount, successURL, failureURL, recurrentSave, recurrentCardId])

  useEffect(() => {
    request()
  }, [request])

  return { order, loading }
}
